import {Point, KeyFeaturesView} from './KeyFeatures.types';

export const getPointsForView = (
  data: Point[],
  view: KeyFeaturesView
): Point[] => {
  return data.filter((point: Point) => point.view === view.toLowerCase());
};
